import { Navbar } from "components/Navbar"
import { type PropsWithChildren, useState } from "react"
import { PanelLeftClose, PanelLeftOpen } from "lucide-react"
import { cn } from "@/lib/utils"

const SIDEBAR_STORAGE_KEY = "sidebarCollapsed"

export const PageLayout = ({ children }: PropsWithChildren) => {
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem(SIDEBAR_STORAGE_KEY) === "true"
  )

  const toggleCollapsed = () => {
    setCollapsed((prev) => {
      localStorage.setItem(SIDEBAR_STORAGE_KEY, String(!prev))
      return !prev
    })
  }

  return (
    <div className="min-h-screen" data-testid="app-shell">
      <aside
        data-testid="app-sidebar"
        className={cn(
          "fixed left-0 top-0 z-20 h-screen transition-[width] duration-300 ease-in-out",
          collapsed ? "w-[60px]" : "w-[240px]"
        )}
      >
        <Navbar collapsed={collapsed} onToggle={toggleCollapsed} />
      </aside>
      <main
        data-testid="app-main"
        className={cn(
          "min-h-screen min-w-0 bg-background transition-[margin-left] duration-300 ease-in-out",
          collapsed ? "ml-[60px]" : "ml-[240px]"
        )}
      >
        {children}
      </main>

      {/* Toggle button — floating on the sidebar edge */}
      <button
        type="button"
        data-testid="sidebar-toggle"
        onClick={toggleCollapsed}
        className={cn(
          "fixed top-5 z-30 flex h-7 w-7 items-center justify-center rounded-full border bg-background text-muted-foreground shadow-sm transition-all duration-300 ease-in-out hover:text-foreground",
          collapsed ? "left-[48px]" : "left-[228px]"
        )}
      >
        {collapsed ? (
          <PanelLeftOpen className="h-3.5 w-3.5" />
        ) : (
          <PanelLeftClose className="h-3.5 w-3.5" />
        )}
      </button>
    </div>
  )
}
